import React from "react";
import PropTypes from "prop-types";
import { useSelector } from "react-redux";
import { constants } from "@qgiv/core-js";
import { getCommitmentAgreementDetails } from "@qgiv/p2p-registration";
import { selectIsCms } from "../../../redux/slices/configSlice";
import { selectAllFormSettings } from "../../../redux/slices/formSettingsSlice";
import { selectAllP2pSettings } from "../../../redux/slices/p2pSettingsSlice";
import { selectCmsControlByIdByPage } from "../../../redux/slices/cmsSettingsSlice";
import { selectRegistrationsFromRegistration } from "../../../redux/slices/registrationSlice";
import CommitmentAgreement from "./CommitmentAgreement";

const ConnectedCommitmentAgreement = ({ controlId }) => {
    const {
        ENUMS: { DefaultView },
    } = constants;
    const isCms = useSelector(selectIsCms);
    const registrations = useSelector(selectRegistrationsFromRegistration);
    const formSettings = useSelector(selectAllFormSettings);
    const { currency, orgName } = formSettings;
    const p2pSettings = useSelector(selectAllP2pSettings);
    const { timezone = "" } = p2pSettings;

    const control = useSelector((state) =>
        selectCmsControlByIdByPage(
            controlId,
            DefaultView.REGISTRATION_CHECKOUT_STEP,
            state,
        ),
    );
    const { options = {} } = control;
    const { commitments = {} } = options;
    const {
        subsectionHeading = "Commitment Agreement",
        commitmentAgreementForPrimary = "I acknowledge I am responsible for meeting my %CommitmentAmount% fundraising commitment by %CommitmentDeadline%. If I raise less than %CommitmentAmount%, I authorize %OrgName% to charge the difference to my payment method on file.",
        commitmentAgreementForAdditional = "If any participant I'm registering raises less than their commitment amount, I authorize %OrgName% to charge the difference to my payment method on file.",
        commitmentAgreementPaymentDisclaimer = "Each participant can easily change the payment method on file in their fundraising account before the deadline.",
    } = commitments;

    const {
        additionalHasCommitment,
        additionalRegistrantCommitmentDetails,
        formattedOptions,
        primaryHasCommitment,
    } = getCommitmentAgreementDetails(
        registrations,
        commitmentAgreementForPrimary,
        commitmentAgreementForAdditional,
        timezone,
        currency,
        orgName,
        isCms,
    );

    // set agreement header
    const agreementHeader = subsectionHeading;

    // set primary and additional text
    let additionalText;
    let primaryText;

    if (primaryHasCommitment) {
        primaryText = formattedOptions.commitmentAgreementForPrimary;
    }

    if (additionalHasCommitment) {
        additionalText = `${formattedOptions.commitmentAgreementForAdditional}`;
    }

    const commitmentAgreementProps = {
        additionalHasCommitment,
        additionalRegistrantCommitmentDetails,
        additionalText,
        agreementHeader,
        commitmentAgreementPaymentDisclaimer,
        primaryHasCommitment,
        primaryText,
    };

    return <CommitmentAgreement {...commitmentAgreementProps} />;
};

ConnectedCommitmentAgreement.propTypes = {
    controlId: PropTypes.number.isRequired,
};

export default ConnectedCommitmentAgreement;
